'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchSearchFacetsIfNeeded = exports.getFetchFacetsSubmitted = exports.getRawArchivedSearchFacets = exports.getRawUpcomingSearchFacets = exports.LOAD_ARCHIVED_FACETS_SUCCESS = exports.LOAD_UPCOMING_FACETS_SUCCESS = exports.LOAD_FACETS_REQUEST = exports.LOAD_FACETS_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.getRawSearchFacets = getRawSearchFacets;
exports.getRawSearchFacetsByParams = getRawSearchFacetsByParams;
exports.getArchivedAndUpcomingFacetValues = getArchivedAndUpcomingFacetValues;
exports.getSearchAuctionHouseFacetValues = getSearchAuctionHouseFacetValues;
exports.getSearchCountryFacetValues = getSearchCountryFacetValues;

var _user = require('./user');

var _search = require('./search');

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _config = require('../modules/config');

var _uniqBy = require('lodash/uniqBy');

var _uniqBy2 = _interopRequireDefault(_uniqBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_FACETS_FAIL = exports.LOAD_FACETS_FAIL = 'LOAD_FACETS_FAIL';
var LOAD_FACETS_REQUEST = exports.LOAD_FACETS_REQUEST = 'LOAD_FACETS_REQUEST';
var LOAD_UPCOMING_FACETS_SUCCESS = exports.LOAD_UPCOMING_FACETS_SUCCESS = 'LOAD_UPCOMING_FACETS_SUCCESS';
var LOAD_ARCHIVED_FACETS_SUCCESS = exports.LOAD_ARCHIVED_FACETS_SUCCESS = 'LOAD_ARCHIVED_FACETS_SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    facets: {
        archived: [],
        upcoming: []
    },
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_FACETS_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                submitted: true,
                success: false
            });
        case LOAD_UPCOMING_FACETS_SUCCESS:
            return (0, _extends3.default)({}, state, {
                facets: (0, _extends3.default)({}, state.facets, {
                    upcoming: action.payload.facets
                }),
                submitted: false,
                success: true
            });
        case LOAD_ARCHIVED_FACETS_SUCCESS:
            return (0, _extends3.default)({}, state, {
                facets: (0, _extends3.default)({}, state.facets, {
                    archived: action.payload.facets
                }),
                submitted: false,
                success: true
            });
        case LOAD_FACETS_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.searchFacets;
};
var searchFacetsSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.facets;
});

var getRawUpcomingSearchFacets = exports.getRawUpcomingSearchFacets = (0, _reselect.createSelector)(searchFacetsSelector, _user.getUserExcludedFacets, function (facets, exclusions) {
    return (0, _user.annotateFacetExclusions)(facets.upcoming, exclusions);
});

var getRawArchivedSearchFacets = exports.getRawArchivedSearchFacets = (0, _reselect.createSelector)(searchFacetsSelector, _user.getUserExcludedFacets, function (facets, exclusions) {
    return (0, _user.annotateFacetExclusions)(facets.archived, exclusions);
});

function getRawSearchFacets(state) {
    var archiveSearch = (0, _search.isArchivedSearch)(state);
    return archiveSearch ? getRawArchivedSearchFacets(state) : getRawUpcomingSearchFacets(state);
}

function getRawSearchFacetsByParams(state, searchParams) {
    var archiveSearch = (0, _search.isArchivedSearchByParams)(searchParams);
    return archiveSearch ? getRawArchivedSearchFacets(state) : getRawUpcomingSearchFacets(state);
}

function getArchivedAndUpcomingFacetValues(state, facetId) {
    function auctionHouseFilter(facet) {
        return facet.id === facetId;
    }
    var facets = [];
    var doneFacets = [];

    if (getRawUpcomingSearchFacets(state).length) {
        var filtered = getRawUpcomingSearchFacets(state).filter(auctionHouseFilter);
        if (filtered.length) {
            facets = getRawUpcomingSearchFacets(state).filter(auctionHouseFilter)[0].options;
        }
    }
    if (getRawArchivedSearchFacets(state).length) {
        var _filtered = getRawArchivedSearchFacets(state).filter(auctionHouseFilter);
        if (_filtered.length) {
            doneFacets = getRawArchivedSearchFacets(state).filter(auctionHouseFilter)[0].options;
        }
    }

    var uniq = (0, _uniqBy2.default)([].concat((0, _toConsumableArray3.default)(facets), (0, _toConsumableArray3.default)(doneFacets)), function (facet) {
        return facet.id;
    });
    return uniq.length ? (0, _cloneDeep2.default)(uniq) : [];
}

function getSearchAuctionHouseFacetValues(state) {
    return getArchivedAndUpcomingFacetValues(state, 'auctionHouse');
}

function getSearchCountryFacetValues(state) {
    return getArchivedAndUpcomingFacetValues(state, 'countryCode');
}

var getFetchFacetsSubmitted = exports.getFetchFacetsSubmitted = function getFetchFacetsSubmitted(state) {
    return state.ui.searchFacets.submitted;
};

var shouldFetchUpcomingFacets = function shouldFetchUpcomingFacets(state) {
    return state.ui.searchFacets.error || state.ui.searchFacets.facets && state.ui.searchFacets.facets.upcoming && state.ui.searchFacets.facets.upcoming.length === 0;
};

var shouldFetchArchivedFacets = function shouldFetchArchivedFacets(state) {
    return state.ui.searchFacets.error || state.ui.searchFacets.facets && state.ui.searchFacets.facets.archived && state.ui.searchFacets.facets.archived.length === 0;
};

/* ACTION CREATORS */
var loadFacetsResultsFail = function loadFacetsResultsFail(error) {
    return {
        error: true,
        payload: error,
        type: LOAD_FACETS_FAIL
    };
};

var loadFacetsResultsRequest = function loadFacetsResultsRequest() {
    return {
        type: LOAD_FACETS_REQUEST
    };
};

var loadUpcomingFacetsResultsSuccess = function loadUpcomingFacetsResultsSuccess(results) {
    return {
        payload: results,
        type: LOAD_UPCOMING_FACETS_SUCCESS
    };
};

var loadArchivedFacetsResultsSuccess = function loadArchivedFacetsResultsSuccess(results) {
    return {
        payload: results,
        type: LOAD_ARCHIVED_FACETS_SUCCESS
    };
};

/* UTILITY FUNCTIONS */
var loadFacets = function loadFacets(archiveSearch) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch(loadFacetsResultsRequest());
        var searchStatus = archiveSearch ? _search.DEFAULT_ARCHIVE_STATUSES : _search.DEFAULT_LIVE_STATUSES;
        var searchQuery = {
            options: {
                status: searchStatus
            }
        };

        return _api.Search.fetchSearchFacetsResults({ deployment: deployment, searchQuery: searchQuery }).then(function (results) {
            if (results.errorMessage) {
                dispatch(loadFacetsResultsFail(results));
            } else {
                var successResult = archiveSearch ? loadArchivedFacetsResultsSuccess(results) : loadUpcomingFacetsResultsSuccess(results);
                dispatch(successResult);
            }
        }).catch(function (error) {
            dispatch(loadFacetsResultsFail(error));
        });
    };
};

var fetchSearchFacetsIfNeeded = exports.fetchSearchFacetsIfNeeded = function fetchSearchFacetsIfNeeded(archiveSearch) {
    return function (dispatch, getState) {
        var state = getState();
        var shouldLoadFacets = archiveSearch ? shouldFetchArchivedFacets(state) : shouldFetchUpcomingFacets(state);
        if (shouldLoadFacets) {
            return dispatch(loadFacets(archiveSearch));
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/searchFacets.js
// module id = XTPq
// module chunks = 57